// Ana container animasyonu
export const containerAnimation = {
  initial: { opacity: 0, y: 100 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.125,
      ease: [0.25, 0.1, 0.25, 1],
      staggerChildren: 0.6
    }
  }
}

// Child animasyonu
export const childAnimation = {
  initial: { opacity: 0, y: 60 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
}

// Ana resim animasyonu (tüm elementler bitene kadar scale)
export const imageAnimation = {
  initial: { opacity: 0, scale: 1.2 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 2.4, // Tüm elementlerin toplam süresi (0.6 + 0.9 + 0.9 = 2.4s)
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
}

// Hızlı animasyon (SVG'ler için)
export const fastAnimation = {
  initial: { opacity: 0, y: 20 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.225,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
}

// Hızlı container animasyonu (8. section için)
export const fastContainerAnimation = {
  initial: { opacity: 0, y: 100 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.125,
      ease: [0.25, 0.1, 0.25, 1],
      staggerChildren: 0.15
    }
  }
}

// Line animasyonu (genişlik 0'dan 100%'e + aşağıdan yukarıya)
export const lineAnimation = {
  initial: { width: "0%", y: 50, opacity: 0 },
  animate: {
    width: "100%",
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.9,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
}

// Hover animasyonu (sadece a etiketleri için)
export const hoverAnimation = {
  whileHover: {
    scale: 1.05,
    transition: {
      duration: 0.3,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
}

